import { render, staticRenderFns } from "./BarChartSimple.vue?vue&type=template&id=4a9e69f0&"
import script from "./BarChartSimple.vue?vue&type=script&lang=js&"
export * from "./BarChartSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports